let ctx: AudioContext | null = null;

function getCtx(): AudioContext {
    if (!ctx) ctx = new AudioContext();
    return ctx;
}

/**
 * iOS Safari requires actually playing audio during a user gesture to truly
 * activate AudioContext. Just calling resume() is not enough — a silent buffer
 * must be played so iOS considers the context "active" for future async use.
 */
export function unlockAudioContext(): void {
    try {
        const audioCtx = getCtx();
        audioCtx.resume().then(() => {
            // Play a 1-frame silent buffer to truly unlock on iOS
            const silentBuffer = audioCtx.createBuffer(1, 1, 22050);
            const source = audioCtx.createBufferSource();
            source.buffer = silentBuffer;
            source.connect(audioCtx.destination);
            source.start(0);
        });
    } catch {
        // AudioContext not supported
    }
}

export function playNotificationSound(): void {
    try {
        const audioCtx = getCtx();
        const play = () => {
            const now = audioCtx.currentTime;
            const playTone = (freq: number, start: number, dur: number) => {
                const osc = audioCtx.createOscillator();
                const gain = audioCtx.createGain();
                osc.connect(gain);
                gain.connect(audioCtx.destination);
                osc.frequency.value = freq;
                osc.type = "sine";
                gain.gain.setValueAtTime(0.3, start);
                gain.gain.exponentialRampToValueAtTime(0.001, start + dur);
                osc.start(start);
                osc.stop(start + dur);
            };
            playTone(880, now, 0.15); // A5
            playTone(1108.7, now + 0.15, 0.3); // C#6
        };
        if (audioCtx.state === "suspended") {
            audioCtx.resume().then(play);
        } else {
            play();
        }
    } catch {
        // AudioContext not supported
    }
}
